import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AudioPlayer from '@/component/audio/audioPlayer'
import { formattedText } from '@/utils/tool'
import { ossUrl } from '@/api/url'

import './question.scss'

/**
 * 1单选题 3多选题 4判断题
 * @param {*} param0
 * @returns
 */
const Question = ({ question, index = 0 }) => {
  const [showAnswer, setShowAnswer] = useState(false)
  const [imageHeight, setImageHeight] = useState('50px')

  const formattedUrl = (url) => {
    if (url.length <= 0) return url
    if (url.startsWith('http')) {
      return url
    } else {
      return ossUrl + url
    }
  }

  const imageLoad = (event) => {
    const height = event.target.height
    setImageHeight(height + 'px')
  }

  const optionsComponent = (question) => {
    if (question.question_type !== 1 && question.question_type !== 3) return
    const answer = JSON.parse(question.answer)
    return (
      <div className="subject-options">
        {answer.options.map((item) => (
          <div className="option" key={item.option}>
            <span
              dangerouslySetInnerHTML={{
                __html: formattedText(item.option),
              }}
            ></span>{' '}
            <span
              dangerouslySetInnerHTML={{
                __html: formattedText(item.answer),
              }}
            ></span>
          </div>
        ))}
      </div>
    )
  }

  const answerComponent = (question) => {
    if (question.question_type !== 1 && question.question_type !== 3) return

    const answer = JSON.parse(question.answer)
    return (
      <div>
        <span
          style={{ marginRight: '5px' }}
          dangerouslySetInnerHTML={{
            __html: formattedText(answer.right_option),
          }}
        ></span>
      </div>
    )
  }

  return (
    <div className="question-container">
      <div className="subject">
        <div className="subject-left">
          <span>{index + 1}、</span>
          <div
            dangerouslySetInnerHTML={{
              __html: formattedText(question.content),
            }}
            style={{ fontSize: '16px' }}
          ></div>
        </div>
        {question.question_type === 4 && (
          <span className="enclosed">(&nbsp;&nbsp;&nbsp;)</span>
        )}
      </div>

      {question.question_source && (
        <div className="audio-item">
          <AudioPlayer audioSrc={formattedUrl(question.question_source)} />
        </div>
      )}

      {optionsComponent(question)}

      <div className="answer-parse-view">
        <p className="answer-parse" onClick={() => setShowAnswer(!showAnswer)}>
          {showAnswer ? '收起' : '答案解析'}
        </p>
        {showAnswer && (
          <div className="content-of-the-answer">
            <div className="answer">
              <span>[答案] </span>
              {answerComponent(question)}
            </div>
            <div className="parsing">
              <div className="tag">[解析] </div>
              {question.explanation && question.explanation.length > 0 && (
                <div className="explanation">{question.explanation}</div>
              )}
              {question.explanation_url &&
                question.explanation_url.length > 0 && (
                  <div className="explanation-image">
                    <img
                      className="image"
                      src={formattedUrl(question.explanation_url)}
                      alt=""
                      style={{ height: imageHeight, width: 'auto' }}
                      onLoad={imageLoad}
                    />
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Question.propTypes = {
  question: PropTypes.object.isRequired,
}

export default Question
